import { Component, OnInit } from '@angular/core';

import { ApiResponse } from 'src/app/shared/interfaces/api-response';
import { StrikeDetail } from "src/app/shared/interfaces/strike-details";
import {StrikeHouse, StrikeHouses} from "src/app/shared/interfaces/strike-houses";

import { ModalService } from '../../../core/modal.service';
import { NotificationService } from '../../../core/notification.service';
import { StrikeService } from '../../../core/strike.service';

@Component({
  selector: 'app-add-house-modal',
  templateUrl: './add-house-modal.component.html',
  styleUrls: ['./add-house-modal.component.css']
})
export class AddHouseModalComponent implements OnInit{
  strike : StrikeDetail = {
    weekNumber: 0,
    dayNumber: 0,
  };
  loadingStrikeHouses = true;
  allHouses: StrikeHouses = [];
  selectedHouse: StrikeHouse = {
    ID: 0,
    StrikeInfoId: 0,
    HouseId: "",
    HouseName: "",
    NoOfEmployees: 0,
  };

  disableButton = false;

  constructor(private strikes: StrikeService, private notificationService: NotificationService, private modal: ModalService) { }

  ngOnInit() {
    this.loadAllStrikeHouses()
  }

  async loadAllStrikeHouses() {
    this.notificationService.displayInfo('Loading available strike houses for ' + this.strike.Title )
    const response: StrikeHouses = await this.strikes.getAllStrikeHouses();

    if (response.length) {
      this.allHouses = response;
      this.selectedHouse = this.allHouses[0];
    }
    else {
      this.notificationService.displayError('There was an error loading houses')
    }
    this.loadingStrikeHouses = false;
  }

  async addStrikeHouse() {
    const newStrikeHouse : StrikeHouse = {
      StrikeInfoId: Number(this.strike.ID),
      HouseId: this.selectedHouse.HouseId,
      HouseName: this.selectedHouse.HouseName
    }

    this.notificationService.displayInfo('Adding ' + newStrikeHouse.HouseName);
    this.disableButton = true;

    const response: ApiResponse = await this.strikes.addStrikeHouse(newStrikeHouse);

    if (response.success) {
      this.notificationService.displaySuccess('House added to the strike successfully')
    }
    else {
      this.notificationService.displayError('There was an error adding the house')
    }

    this.modal.submitClicked.next(true);
    this.disableButton = false;
    this.modal.closeModal()
  }

  closeModal() {
    this.modal.closeModal();
  }
}
